module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/logo_kv-d77d7d0497872107d6fd6ffe855e555f.png";